// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v710demo1', //METRONIC
  USERDATA_KEY: 'authf649fc9a5f55', // METRONIC
  isMockEnabled: false, // METRONIC
  apiUrl: 'http://51.79.78.171:7003/', //.NETAPI
  // dev.apiUrlG12Connect: 'https://dev.api.g12connect.com/dev.api/v2/',
  apiUrlG12Connect: {
    donations: 'https://qa.api.g12connect.com/api/v2/donations',
      managment: 'https://qa.api.g12connect.com/api/v2/managment',
      users: 'https://qa.api.g12connect.com/api/v2/users',
      payments: 'https://qa.api.g12connect.com/api/v2/payments',
      paymentsv3: 'https://qa.api.g12connect.com/api/v3/payments',
      reports: 'https://qa.api.g12connect.com/api/v2/reports',
  },
  SECRETENCRYPT: 'G12jk5FQg6bu8zWSECURITY#wB9jPyURESPONSE',
  url_response: 'https://dev.mci12.com/g12events/proof-payment',
  reports_lamda:
    'https://1cd3-2800-484-3690-6500-197e-9881-56e6-162.ngrok.io/dev',
  url_change_password: 'https://dev.mci12.com/auth/change-password',
  firebaseConfig: {
    apiKey: "AIzaSyDB9T9w2BnOWxI7SbtJuvuEp9lxmM3Xnuw",
    authDomain: "g12-media.firebaseapp.com",
    projectId: "g12-media",
    storageBucket: "g12-media.appspot.com",
    messagingSenderId: "218019509549",
    appId: "1:218019509549:web:8998da7ac9d727c7d5cfa4"
  },
  url_g12_events: 'https://dev.eventosg12.com/home',
  url_donations: 'https://dev.mcidonaciones.com/donations',
  url_api: 'https://9oihqjgmad.execute-api.us-east-2.amazonaws.com/prod/api',
  url_api_wp: 'https://blog.iglesiamci.org/wp-json/wp/v2'
};
